export class UpdateBackupZeroEtlPolicyInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupZeroEtlResourceSelector",
            "format": ""
        },
        {
            "name": "catalogConfiguration",
            "baseName": "catalogConfiguration",
            "type": "BackupZeroEtlCatalogConfiguration",
            "format": ""
        },
        {
            "name": "storageConfiguration",
            "baseName": "storageConfiguration",
            "type": "BackupZeroEtlStorageConfiguration",
            "format": ""
        },
        {
            "name": "accessConfiguration",
            "baseName": "accessConfiguration",
            "type": "BackupZeroEtlAccessConfiguration",
            "format": ""
        },
        {
            "name": "routingPolicy",
            "baseName": "routingPolicy",
            "type": "BackupZeroEtlRoutingPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateBackupZeroEtlPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
